export default {
	headers: {
		financialFiles: 'الملف المالي',
		user: 'المستخدم',
		change: 'التغيير',
		changeType: 'نوع التغيير',
		date: 'التاريخ',
		description: 'التوصيف'
	},
	label: {
		logType: 'نوع السجل',
		user: 'المستخدم',
		fromDate: 'من تاريخ',
		toDate: 'إلى تاريخ'
	},

	accounts: 'الحسابات',
	accounting: 'محاسبة',
	currencies: 'العملات',
	'financial-file': 'الملف المالي',
	'fund-flow': 'حركة مالية',
	manufacturing: 'تصنيع',
	'material-flow': 'حركات المواد',
	'material-warehouse': 'مواد مستودع',
	users: 'مستخدمين',


	fetch: 'قراءة',
	create: 'إنشاء',
	update: 'تحديث',
	delete: 'حذف',

	search: 'بحث'
}